<template>
    <NuxtLayout name="malt-base-layout">
        <Navbar show-search-unlogged :is-funnel-mode="isFunnelMode" />
        <main class="advanced-search-app">
            <slot />
        </main>
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {computed, onMounted} from 'vue';
    import {useNavbarDisplayModeStore} from '@navbar/public-api';
    import {useRoute} from '@typed-router';
    import {storeToRefs} from 'pinia';
    import {Navbar} from '#components';
    import {useAuth} from '#imports';

    const displayModeStore = useNavbarDisplayModeStore();

    const {loggedIn} = storeToRefs(useAuth());

    const route = useRoute();
    const isFunnelMode = computed(() => route.meta.isFunnelMode === true);

    // TODO => try to solve that with deep dive navbar behavior
    onMounted(() => {
        if (loggedIn.value) {
            displayModeStore.setNavbarDisplayMode();
        }
    });
</script>

<style scoped lang="scss">
    .advanced-search-app {
        background-color: var(--joy-color-neutral-10);
        min-height: calc(100vh - var(--layout-padding-top, 72px));
        display: flex;
        justify-content: center;
    }
</style>
